// extracted by mini-css-extract-plugin
export default {"wrapper":"ButtonIcon_wrapper__zZdzx","iconWrapper":"ButtonIcon_iconWrapper__K0PfM"};